// extracted by mini-css-extract-plugin
module.exports = {"form":"FormComment_form__3Pb0P","textarea":"FormComment_textarea__2fACP","buttonGroup":"FormComment_buttonGroup__3HLrQ","submitButton":"FormComment_submitButton__1vL0W"};